import { defineMessages } from 'react-intl';

export default defineMessages({
  matomoVisits: 'Visits',
  matomoActions: 'Actions',
  questionResponses: 'Survey responses',

  visitLastActionTime: 'Visit last action time',
  visitActions: 'Visit action count',
  visitEvents: 'Visit event count',
  visitInteractions: 'Visit interaction count',
  visitSearches: 'Visit search count',
  visitTotalTime: 'Visit total time',
  visitEntryUrl: 'Visit entry URL',
  visitEntryTitle: 'Visit entry title',
  visitExitUrl: 'Visit exit URL',
  visitExitTitle: 'Visit exit title',
  visitGoalConverted: 'Visit converted a goal',
  visitorReturning: 'Visitor is returning',
  visitorVisitCount: 'Visitor visit count',
  visitorSecondsSinceFirstVisit: 'Visitor seconds since first visit',
  visitorSecondsSinceLastVisit: 'Visitor seconds since last visit',
  visitorCountry: 'Visitor country',
  visitorCity: 'Visitor city',
  deviceType: 'Device type',
  deviceBrand: 'Device brand',
  deviceOs: 'Device OS',
  deviceOsVersion: 'Device OS version',
  browserName: 'Browser name',
  browserVersion: 'Browser version',
  browserLanguage: 'Browser language',
  browserCookies: 'Browser cookies enabled',
  referrerType: 'Referrer type',
  referrerKeyword: 'Referrer keyword',
  referrerUrl: 'Referrer URL',
  referrerName: 'Referrer name',
  campaignContent: 'Campaign content',
  campaignGroup: 'Campaign group',
  campaignKeyword: 'Campaign keyword',
  campaignMedium: 'Campaign medium',
  campaignName: 'Campaign name',
  campaignSource: 'Campaign source',
  campaignId: 'Campaign ID',
  campaignPlacement: 'Campaign placement',

  surveyGroupId: 'Survey',
  surveyResponseTime: 'Survey response time',
  surveyResponsePageUrl: 'Survey response page URL',
  surveyResponsePageTitle: 'Survey response page title',
  surveyResponseClientPanel: 'Survey response client panel participant',
  surveyRespondentDeviceType: 'Survey respondent device type',
  surveyRespondentCountry: 'Survey respondent country',
  surveyRespondentBrowserLanguage: 'Survey respondent browser language',
  questionResponseQuestionId: 'Survey question',
  questionResponseQuestionType: 'Survey question type',
  questionResponseOptionId: 'Question options',
  questionResponseText: 'Question response text',
});
